var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" Select Vendor "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c("li", [
              _c("div", { staticClass: "field" }, [
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _vm.vendors
                      ? _c(
                          "multiselect",
                          {
                            attrs: {
                              "track-by": "name",
                              label: "name",
                              disabled: !_vm.isNew,
                              "show-labels": false,
                              options: _vm.vendors,
                              "options-limit": _vm.assetFilter.pageSize,
                              loading: _vm.isVendorLoading,
                              "internal-search": false,
                              searchable: true,
                              "allow-empty": false,
                              placeholder: "Select a Vendor",
                            },
                            on: {
                              select: _vm.selectVendor,
                              remove: _vm.removeVendor,
                              "search-change": _vm.getVendorDropdownFilter,
                            },
                            model: {
                              value: _vm.selectedVendor,
                              callback: function ($$v) {
                                _vm.selectedVendor = $$v
                              },
                              expression: "selectedVendor",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "has-text-danger",
                                attrs: { slot: "noResult" },
                                slot: "noResult",
                              },
                              [_vm._v("Factorer not found.")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("hr"),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }